import React from 'react';
import { Link } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/message/XTYPH2HUY3L6L1';

// Iter 539 (Kamel) — « Payer » = porte d'entrée : tous les règlements se font depuis l'Espace Adhérent.
const MODES = [
  ['🏦', 'Virement bancaire', 'Le plus simple : instantané et sans frais, IBAN à copier dans votre espace.', 'reco'],
  ['💳', 'Carte bancaire', 'En ligne via HelloAsso, depuis votre espace (montant à saisir).', ''],
  ['✉️', 'Chèques-vacances papier ou chèque bancaire', "Par courrier, à l'adresse indiquée dans votre espace.", ''],
  ['💵', 'Espèces ou chèques-vacances papier en main propre', 'Uniquement sur rendez-vous à la permanence (Decathlon Bron, 10 min, reçu et facture immédiats).', ''],
];

export default function PaymentPage() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]" data-testid="payment-page">
      <section className="bg-[#1E3A5F] text-white py-10 sm:py-14 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl sm:text-4xl font-bold">💶 Régler mon voyage</h1>
          <p className="mt-3 text-sm sm:text-base text-gray-200">
            Acompte, paliers ou solde : <strong>tout se règle depuis votre Espace Adhérent</strong>, à distance, sans vous déplacer.
            Vous y voyez votre reste à payer exact, vos règlements déjà enregistrés et votre facture.
          </p>
          <Link to="/moi?payer=1" data-testid="payer-vers-espace"
            className="inline-block mt-6 bg-amber-500 hover:bg-amber-600 text-white font-bold px-8 py-4 rounded-2xl text-base shadow-lg transition">
            👤 Ouvrir mon espace pour régler →
          </Link>
          <p className="mt-2 text-xs text-gray-300">Votre e-mail ou votre téléphone, un code reçu par e-mail — la première fois seulement.</p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-4 py-8 space-y-6">
        <div className="bg-white border-l-4 border-amber-400 rounded-xl shadow-sm px-5 py-4 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="payment-prerequisite">
          <div className="flex-grow">
            <p className="font-bold text-[#1E3A5F] text-sm sm:text-base">Pas encore inscrit ?</p>
            <p className="text-xs sm:text-sm text-gray-700">Remplissez d'abord le formulaire : votre espace s'ouvre juste après, avec le montant à régler. Aucune inscription n'est validée sans formulaire — et <strong>pas de fiche, pas de règlement ni de rendez-vous</strong>.</p>
          </div>
          <Link to="/inscription" data-testid="goto-inscription" className="shrink-0 bg-[#79c9ea] hover:bg-[#5ba8c8] text-white font-bold px-5 py-2.5 rounded-xl text-sm text-center transition">Remplir le formulaire</Link>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-5 sm:p-6" data-testid="payment-modes">
          <h2 className="text-base md:text-lg font-bold text-[#1E3A5F] mb-3">Les 4 façons de régler</h2>
          <ul className="space-y-2.5">
            {MODES.map(([ico, titre, txt, tag]) => (
              <li key={titre} className="flex items-start gap-3 bg-gray-50 rounded-xl p-3">
                <span className="text-2xl" aria-hidden="true">{ico}</span>
                <div>
                  <p className="text-sm font-bold text-[#1E3A5F]">{titre} {tag === 'reco' && <span className="ml-1 text-[10px] uppercase bg-emerald-100 text-emerald-800 px-2 py-0.5 rounded-full font-extrabold">⭐ recommandé</span>}</p>
                  <p className="text-xs text-gray-600 leading-snug">{txt}</p>
                </div>
              </li>
            ))}
          </ul>
          <div className="mt-4 bg-red-50 border border-red-200 rounded-xl p-3 text-xs text-red-900" data-testid="rdv-pas-de-cb">
            <p className="font-bold">🚫 Pas de carte bancaire ni de virement à la permanence</p>
            <p className="mt-0.5 leading-snug">Nous n'avons aucun terminal de paiement : la carte et le virement se font 100 % en ligne depuis votre espace. La permanence, c'est <strong>uniquement</strong> pour les espèces et les chèques-vacances papier, sur rendez-vous.</p>
          </div>
          <p className="mt-3 text-[11px] text-gray-500 italic">📅 Échéancier : 20 % à l'inscription · 50 % cumulés à 6 mois du départ · totalité 45 jours avant le départ. Sorties à la journée : en totalité à l'inscription.</p>
        </div>

        <div className="bg-white rounded-2xl shadow p-4 text-center space-y-2" data-testid="rdv-questions-distance">
          <p className="text-sm font-bold text-[#1E3A5F]">❓ Une question ? Pas besoin de rendez-vous</p>
          <p className="text-xs text-gray-600">Tout est écrit sur le site : <Link to="/comment-sinscrire" className="underline font-semibold">comment s'inscrire</Link>, <Link to="/faq" className="underline font-semibold">FAQ</Link>, <Link to="/informations-administratives" className="underline font-semibold">infos administratives</Link>. Pour le reste, l'assistant de votre espace ou l'équipe :</p>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 bg-[#25D366] hover:bg-[#1DA851] text-white px-4 py-2 rounded-xl text-xs font-bold transition" data-testid="ask-mail-address">💬 WhatsApp 06 60 41 62 18</a>
        </div>
      </div>
    </div>
  );
}
